import type { BasedFunctionConfig } from '@based/sdk/functions'

export default {
  type: 'query',
  name: 'list-user-initiative',
  public: false,
} as BasedFunctionConfig
